<template>
  <div class="vipBox">
    <div class="he50"></div>
    <div class="he50"></div>
    <div class="vipMain">
      <div class="vipTab">
        <span
          :class="{ spanAct: pageType === 'page1' }"
          @click="toPage('page1')"
          >个人会员</span
        >
        <span
          :class="{ spanAct: pageType === 'page2' }"
          @click="toPage('page2')"
          >团体会员</span
        >
      </div>
      <div class="vipPage1 pageVip" v-if="pageType === 'page1'">
        <img :src="code" alt />
        <p>扫描二维码填写资料</p>
      </div>
      <div class="vipPage2 pageVip" v-if="pageType === 'page2'">
        <el-form
          :model="unitObj"
          ref="unitObjForm"
          label-width="0px"
          class="demo-ruleForm"
          :rules="unitRules"
        >
          <div class="vip-name">会员单位名称</div>
          <div class="vip-input">
            <el-form-item prop="companyName">
              <el-input
                v-model="unitObj.companyName"
                placeholder="请输入会员单位名称"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">联系人姓名</div>
          <div class="vip-input">
            <el-form-item prop="num">
              <el-input
                v-model="unitObj.num"
                placeholder="请输入联系人姓名"
              ></el-input>
            </el-form-item>
          </div>
          <div class="vip-name">联系电话</div>
          <div class="vip-input">
            <el-form-item prop="mobile">
              <el-input
                v-model="unitObj.mobile"
                placeholder="请输入联系电话"
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
        <div class="button" @click="applyFor">立即申请</div>
      </div>
    </div>
    <div class="he50"></div>
    <div class="he50"></div>
  </div>
</template>

<script>
import code from "@/assets/img/home/code.png";
import { applyForCompanyMember } from "@/api/api.js";
export default {
  data() {
    const checkAge = (rule, value, callback) => {
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (value === "") {
        callback(new Error("手机号不能为空"));
      } else if (!myreg.test(value)) {
        callback(new Error("请输入正确的手机号"));
      } else {
        callback();
      }
    };
    const numRex = (rule, value, callback) => {
      // let myreg = /^[+]{0,1}(\d+)$/;
      if (value === "") {
        callback(new Error("联系人姓名不能为空"));
      } else {
        callback();
      }
    };
    return {
      code,
      pageType: "page1",
      // 单位
      unitObj: {
        userId: "",
        companyName: "",
        num: "",
        mobile: ""
      },
      unitRules: {
        companyName: [{ required: true, message: "公司名称不能为空" }],
        num: [{ validator: numRex }],
        mobile: [{ validator: checkAge }]
      }
    };
  },
  watch: {
    $route(newValue) {
      this.toPage(newValue.query.pages);
    }
  },
  mounted() {
    this.toPage(this.$route.query.pages);
  },
  methods: {
    toPage(val) {
      if (val) {
        this.pageType = val;
      } else {
        this.pageType = "page1";
      }
    },
    applyFor() {
      this.$refs.unitObjForm.validate(valid => {
        if (valid) {
          this.applyForCompanyMember();
        } else {
          return false;
        }
      });
    },
    applyForCompanyMember() {
      applyForCompanyMember(this.unitObj).then(res => {
        if (res.code === 0) {
          this.$message({
            message: "您已申请成功",
            type: "success"
          });
          // this.$router.push({ name: "H5my" });
          this.unitObj = {
            userId: "",
            companyName: "",
            num: "",
            mobile: ""
          };
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
//
.vipMain {
  margin: 0 auto;
  width: 478px;
  height: 472px;
  box-shadow: 0px 4px 16px 0px rgba(46, 32, 45, 0.1);
  border-radius: 10px;
  overflow: hidden;
  .vipTab {
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    span {
      display: inline-block;
      margin: 0 30px;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      font-weight: bold;
      color: rgba(52, 52, 52, 1);
      cursor: pointer;
    }
    .spanAct {
      color: rgba(108, 45, 102, 1);
      border-bottom: 2px solid #6c2c66;
    }
  }
  .pageVip {
    padding: 16px;
    width: 100%;
    height: calc(100% - 72px);
    box-sizing: border-box;
  }
  .vipPage1 {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 240px;
      height: 240px;
    }
  }
  .vipPage2 {
    padding: 40px;
    .vip-name {
      margin-bottom: 10px;
      font-size: 14px;
      color: #141414;
    }
    .button {
      margin: 30px auto 0;
      width: 320px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      background: #6c2c66;
      border-radius: 4px;
      font-size: 18px;
      color: #ffffff;
    }
    //    .vip {
    //   width: 100%;
    //   padding: 16px;
    //   box-sizing: border-box;
    //   &-title {
    //     margin: 10px 0;
    //     font-size: 10px;
    //     color: #787f87;
    //   }
    //   &-name {
    //
    //   }
    //

    // }
  }
}
</style>
